<template>
  <div class="live-item">
    <div class="item-content" :style="`background-image: url(${item.cover})`">
      <img class="play-img" src="../../assets/images/play.png" alt="壹心理直播-列表">
      <div class="preview-box">
        <div class="notice-box">
          <SvgIcon icon-class="collection" class-name="collection"></SvgIcon>
          合集
        </div>
        <img
          class="icon-nav"
          :src="require('../../assets/images/icon-video.png')"
          alt="壹心理直播"
        />
      </div>
      <div class="description" v-html="item.collectionDesc" />
    </div>

    <div class="image-shadow">
      <span></span>
      <span :style="`background-image: url(${item.cover})`"></span>
      <span></span>
      <span :style="`background-image: url(${item.cover})`"></span>
    </div>
  </div>
</template>

<script>
  import SvgIcon from 'components/SvgIcon'
  export default {
    name: "collection",
    components: { SvgIcon },
    props: {
      item: {
        type: Object,
        default: ()=>{}
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins.scss";

  .live-item {
    position: relative;
    margin-top: 40px;
    width: 100%;
    height: 442px;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .item-content {
      position: absolute;
      height: 100%;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: 1;
      border-radius: 10px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  .image-shadow {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      position: absolute;
      top: 0;
      border-radius: 10px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    span:nth-child(1) {
      width: 75%;
      height: 75%;
      transform: translateY(-40px);
      background: #fff;
    }
    span:nth-child(2) {
      width: 75%;
      height: 75%;
      transform: translateY(-40px);
      opacity: 0.2;
    }
    span:nth-child(3) {
      width: 87%;
      height: 87%;
      transform: translateY(-20px);
      background: #fff;
    }
    span:nth-child(4) {
      width: 87%;
      height: 87%;
      transform: translateY(-20px);
      opacity: 0.5;
    }
  }

  .preview-box {
    position: absolute;
    top: 16px;
    left: 16px;
    right: 16px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .notice-box {
      font-size: 20px;
      color: #FFFFFF;
      font-weight: bold;
      height: 42px;
      background: rgba(0, 0, 0, .4);
      border-radius: 5px;
      display: flex;
      align-items: center;
      padding-left: 12px;
      padding-right: 17px;
      
      /deep/ .collection {
        width: 26px;
        height: 26px;
        margin-right: 15px;
      }
    }

    .icon-nav {
      display: block;
      width: 26px;
      height: 26px;
    }
  }

  .description {
    position: absolute;
    bottom: 16px;
    left: 16px;
    right: 16px;
    font-size: 24px;
    color: #FFFFFF;
    @include overLine(1);
  }

  .play-img {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -30px;
    margin-top: -30px;
    width: 60px;
    height: 60px;
  }
</style>
